import React, { useEffect, useRef } from 'react';
import { WidgetConfigProps } from './types';
import './style.scss'

export interface WidgetEmbedProps {
  config: WidgetConfigProps;
  formId: string;
  previewType?: string;
}
const baseURL=process.env.REACT_APP_FORM_URL
const EmbeddingForm: React.FC<WidgetEmbedProps> = ({ config, formId, previewType }) => {

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if ((window as any)?.applyWidgetConfig) {
      (window as any).applyWidgetConfig(config)
    }
  }, [config])

  useEffect(() => {
    if (containerRef.current && (window as any)?.widgetConfig) {
      (window as any).widgetConfig(containerRef.current);
    }
  }, []);

  return (
    <div className='previewType'>
      <div ref={containerRef} className="EmbedFormContainer" id={previewType === "pc" ? "pcWidth" : previewType === "mobile" ? "mobileWidth" : ""}>
        <div id="myForm" form-id={formId} base-URL={baseURL}></div>
      </div>
    </div>
  );
};
export default EmbeddingForm;